import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.spaceLite',
    'resource:solutions.apps.spaceLite.pages.recordDetails',
    'resource:solutions.apps.spaceLite.pages.recordsList',
    'resource:solutions.apps.spaceLite.pages.surveyConfiguration',
    'resource:solutions.apps.spaceLite.pages.userAccess',
    'resource:solutions.apps.spaceLite',
  ],
  description: 'Space Lite',
  name: 'Space Lite',
} as const satisfies core.quiver.Package
